<div class="gmb-96 gmb-md-56"></div>

<app-form-page-footer [ngClass]="modal ? 'bg-white' : 'bg-lightblue-2'">
  <div class="d-sm-inline-flex d-flex gmb-sm-16 flex-column flex-sm-row">
    <button
      *ngIf="editMode"
      (click)="openDeleteConfirmation()"
      type="button"
      class="gbtn-red-2 gbtn-sq b2-semibold w-100 d-inline-flex align-items-center justify-content-center"
      [disabled]="isLoading"
      gptDataTrack="analyses-edit-delete"
    >
      <span class="d-none d-md-block text-nowrap text-danger">
        {{ 'ANALYSES.DELETE.ACTION' | translate }}
      </span>
      <span class="d-block d-md-none text-nowrap text-danger">
        {{ 'ANALYSES.DELETE.ACTION_MOBILE' | translate }}
      </span>
    </button>

    <button
      type="submit"
      class="gbtn-1 gbtn-sq gbtn-spinner b2-semibold w-100 gml-sm-16 gmt-16 gmt-sm-0"
      gptDataTrack="analyses-edit-submit
  "
      [disabled]="!formValid || isLoading"
    >
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
      <span class="d-none d-md-block text-nowrap">
        {{
          (editMode ? 'ANALYSES.EDIT.ACTION' : 'ANALYSES.ADD.TITLE') | translate
        }}
      </span>
      <span class="d-block d-md-none text-nowrap">
        {{
          (editMode ? 'ANALYSES.EDIT.ACTION_MOBILE' : 'ANALYSES.ADD.TITLE')
            | translate
        }}
      </span>
    </button>
  </div>
</app-form-page-footer>
